import appReducer from './appReducer'
import metaDataReducer from './metaDataReducer'
import authenticationReducer from './apiReducers/authenticationReducer'
import registerReducer from './apiReducers/registerReducer'
import serviceAvailableReducer from './apiReducers/serviceAvailableReducer'
import calendarReducer from './calendar/calendarReducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  app: appReducer,
  metaData: metaDataReducer,
  authentication: authenticationReducer,
  register: registerReducer,
  serviceAvailable: serviceAvailableReducer,
  calendar: calendarReducer,
})

export default rootReducer
